import commitSelection from './commitSelection';

export const buildSelectionFeedback = (selection, result, commitOptions = {}) => {
  if (result.ok) return null;

  if (result.reason === 'incompatibleContext') {
    return {
      reason: 'incompatibleContext',
      currentContext: result.currentContext ?? selection.context ?? null,
      attemptedContext: result.attemptedContext ?? null,
      ...(commitOptions.switchToEntry ? {
        attemptedEntry: commitOptions.switchToEntry,
        source: commitOptions.source || null,
      } : {}),
    };
  }

  return { reason: result.reason };
};

export default function applySelectionCommitToState(state, commitOptions) {
  const { selection, result } = commitSelection(state.ui.selection, commitOptions);
  state.ui.selection = selection;
  state.ui.selectionFeedback = buildSelectionFeedback(selection, result, commitOptions);
}
